import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
 
export const Landingview = () => {
	return(
    <Container fluid style={{background:'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(/assets/images/Start4.jpg)', backgroundSize: 'cover'}}>     
      <Container className="fablab-container" id="que-es-fablab">
        <Row>
          <Col className="text-center">
            <h1 className="fablab-title white">FabLab UTFSM le da la bienvenida</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <h2 className="fablab-subtitle white">Un lugar para avanzar</h2>
            <p className="white">FabLab UTFSM es un laboratorio de fabricación que nace como una iniciativa estudiantil el año 2014, destinada a facilitar todas las herramientas digitales y físicas posibles para que cualquier persona pueda crear, fabricar y transformar sus ideas en algo material.</p>
            <p className="white">Gracias a su carácter multipropósito, las instalaciones permiten el acceso tanto a la comunidad universitaria, ya sean estudiantes o profesores, como a personas externas que cuenten con una membresía vigente.</p>
          </Col>
          <Col className="text-center d-none d-md-block">
            <Container className="super-iframe-holder">
              <iframe title="YouTube video player" border="none" frameBorder="0" scrolling="auto" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen src="https://www.youtube.com/embed/De8VA8_zVE8" ></iframe>
            </Container>
          </Col>
          <Col className="text-center d-block d-md-none" xs="12">
            <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="https://www.youtube.com/watch?v=De8VA8_zVE8&ab_channel=FabLabUTFSM">Más información <FontAwesomeIcon className="fablab-button-circle white" icon={faArrowRight}/></a>
          </Col>
        </Row>
      </Container>
    </Container>
	)
}